<div class="job-detail-info">
  <div class="info-block">
    <label class="info-label">Location</label>
    <p class="info-value">{{ job.location }}</p>
    <div class="info-separator"></div>
  </div>

  <div class="info-block">
    <label class="info-label">Employment Type</label>
    <p class="info-value">{{ job.employmentType }}</p>
    <div class="info-separator"></div>
  </div>

  <div class="info-block">
    <label class="info-label">Minimum Experience</label>
    <p class="info-value">{{ job.minExperience?.includes('Year') ? job.minExperience : job.experienceLevel }}</p>
    <div class="info-separator"></div>
  </div>
</div>
